
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';

@Component({
  components: {},
})
export default class DlgGroupSelector extends Vue {
  @Prop({type: Boolean, default: false}) private loading!: boolean;

  @Action('admin/groups/read') private read!: any;

  @Getter('admin/groups/all') private all!: any;

  private headers: any = [
    {
      text: '',
      align: 'left',
      sortable: false,
      value: '',
      width: '50px',
    },
    {
      text: 'Titel',
      align: 'left',
      value: 'title',
    },
    {
      text: '# Mitglieder',
      align: 'left',
      value: 'membercount',
    },
  ];
  private dialog: boolean = false;

  public close() {
    this.dialog = false;
  }

  private async mounted() {
    if (!this.all || this.all.length === 0) {
      await this.read();
    }
  }

  private addList(group) {
    this.$emit('selected', group);
  }
}
